import { Helmet } from 'react-helmet';
import NewdanhmucnhacungcapDetail
  from 'src/components/newdanhmucnhacungcap-detail/NewdanhmucnhacungcapDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import NewdanhmucnhacungcapListToolbar from '../components/newdanhmucnhacungcap-detail/NewdanhmucnhacungcapToolbar';

const Newdanhmucnhacungcap = () => (
  <>
    <Helmet>
      <title>Danh mục nhà cung cấp</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <NewdanhmucnhacungcapListToolbar />
        <Box sx={{ pt: 3 }}>
          <NewdanhmucnhacungcapDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Newdanhmucnhacungcap;
